/*
==============================================================================
Rcrea | Tabs de texto Güten Brew
Fix mobile acordeón: permite cerrar el tab abierto al volver a tocar el título
==============================================================================
*/

(function () {
  const SECTION_SELECTOR = '[data-gb-text-tabs]';
  const INIT_ATTR = 'data-gb-text-tabs-initialized';

  function getItems(section) {
    const tabButtons = Array.from(section.querySelectorAll('[data-gb-tab-button]'));
    const accordionButtons = Array.from(section.querySelectorAll('[data-gb-accordion-button]'));
    const panels = Array.from(section.querySelectorAll('[data-gb-tab-panel]'));
    const wraps = Array.from(section.querySelectorAll('[data-gb-panel-wrap]'));

    return { tabButtons, accordionButtons, panels, wraps };
  }

  function closeAll(section) {
    const { tabButtons, accordionButtons, panels, wraps } = getItems(section);

    tabButtons.forEach(function (button) {
      button.classList.remove('is-active');
      button.setAttribute('aria-selected', 'false');
      button.setAttribute('tabindex', '-1');
    });

    accordionButtons.forEach(function (button) {
      button.classList.remove('is-active');
      button.setAttribute('aria-expanded', 'false');
    });

    panels.forEach(function (panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('hidden', '');
    });

    wraps.forEach(function (wrap) {
      wrap.classList.remove('is-active');
    });

    section.dataset.gbActiveTab = '';
  }

  function setActive(section, index) {
    const { tabButtons, accordionButtons, panels, wraps } = getItems(section);
    const activeIndex = String(index);

    tabButtons.forEach(function (button) {
      const isActive = button.dataset.gbTabIndex === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    accordionButtons.forEach(function (button) {
      const isActive = button.dataset.gbTabIndex === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      const isActive = panel.dataset.gbTabIndex === activeIndex;
      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    wraps.forEach(function (wrap) {
      const isActive = wrap.dataset.gbTabIndex === activeIndex;
      wrap.classList.toggle('is-active', isActive);
    });

    section.dataset.gbActiveTab = activeIndex;
  }

  function toggleAccordion(section, index) {
    const activeIndex = section.dataset.gbActiveTab;
    const nextIndex = String(index);

    if (activeIndex === nextIndex) {
      closeAll(section);
      return;
    }

    setActive(section, nextIndex);
  }

  function moveFocus(tabButtons, currentIndex, direction) {
    if (!tabButtons.length) return;

    const nextIndex = (currentIndex + direction + tabButtons.length) % tabButtons.length;
    const nextButton = tabButtons[nextIndex];

    if (nextButton) {
      nextButton.focus();
      setActive(nextButton.closest(SECTION_SELECTOR), nextButton.dataset.gbTabIndex);
    }
  }

  function initSection(section) {
    if (!section || section.getAttribute(INIT_ATTR) === 'true') return;

    section.setAttribute(INIT_ATTR, 'true');

    const { tabButtons, accordionButtons } = getItems(section);

    tabButtons.forEach(function (button, position) {
      button.addEventListener('click', function () {
        setActive(section, button.dataset.gbTabIndex);
      });

      button.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveFocus(tabButtons, position, 1);
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveFocus(tabButtons, position, -1);
        }

        if (event.key === 'Home') {
          event.preventDefault();
          if (tabButtons[0]) {
            tabButtons[0].focus();
            setActive(section, tabButtons[0].dataset.gbTabIndex);
          }
        }

        if (event.key === 'End') {
          event.preventDefault();
          const lastButton = tabButtons[tabButtons.length - 1];
          if (lastButton) {
            lastButton.focus();
            setActive(section, lastButton.dataset.gbTabIndex);
          }
        }
      });
    });

    accordionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        toggleAccordion(section, button.dataset.gbTabIndex);
      });
    });

    const currentActive = section.querySelector('[data-gb-tab-button].is-active') || tabButtons[0];

    if (currentActive) {
      setActive(section, currentActive.dataset.gbTabIndex || 0);
    }
  }

  function initAll(scope) {
    const root = scope || document;

    if (root.matches?.(SECTION_SELECTOR)) {
      initSection(root);
    }

    root.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sections = [];

    if (event.target.matches?.(SECTION_SELECTOR)) {
      sections.push(event.target);
    }

    event.target.querySelectorAll?.(SECTION_SELECTOR).forEach(function (section) {
      sections.push(section);
    });

    sections.forEach(function (section) {
      section.removeAttribute(INIT_ATTR);
      initSection(section);
    });
  });
})();
